"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CommercialBanner() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="commercial-banner" id="commercial-banner" className="bg-background text-foreground py-16 md:py-20">
      <div className="container mx-auto px-6 md:px-8 max-w-5xl">
        <div ref={ref} className={`border border-border bg-card rounded-md p-8 md:p-12 shadow-md transition-all duration-700 ease-out flex flex-col md:flex-row md:items-center md:justify-between gap-6 md:gap-8 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="space-y-3 max-w-2xl">
            <div className="flex items-center gap-2">
              <span className="block h-px w-6 bg-primary" />
              <span className="font-mono text-xs uppercase tracking-widest text-primary">
                Commercial
              </span>
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-default text-foreground tracking-tight">
              Commercial Pest Control: protecting local businesses across the Triangle
            </h2>
            <p className="text-sm md:text-base text-muted-foreground font-sans leading-relaxed">
              Targeted treatments and proactive pest management tailored to offices, retail, and commercial properties.
            </p>
          </div>

          <div className="shrink-0">
            <Button asChild className="rounded-md h-auto px-6 py-3 text-sm md:text-base font-bold font-default bg-primary text-primary-foreground hover:bg-primary/90 transition-all shadow-md w-full sm:w-auto">
              <Link href="/commercial-pest-control/">
                Learn More
                <ArrowRight className="ml-2 size-4" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}